import { PrivacyTip, Construction } from '@mui/icons-material';

const Footer = () => {
    return (
        <footer>
            <div className="footer">
                <p style={
                    { display: 'flex', alignItems: 'center', textAlign: 'center'
                    , width: '100%', justifyContent: 'center' }}>
                        <a href='/#/AvisoLegal' 
                            style={{ color: 'inherit', textDecoration: 'none', 
                                fontStyle: 'italic', fontSize: '0.9em', 
                                marginLeft: '5px' }}>
                        <PrivacyTip style={{ marginRight: '0.2em', height: '0.8em' }} />
                        </a> 
                            2021/{new Date().getFullYear()} 
                            Assoc. Motoc. Brasil Extremos ® Direitos Reservados 
                        <a href="https://www.rasquinho.com.br" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            style={{ color: 'inherit', textDecoration: 'none', 
                                fontStyle: 'italic', fontSize: '0.9em', 
                                marginLeft: '5px' }}> 
                        {<Construction style={{ height: '0.8em' }} />}
                        </a>
                    </p>
            </div>
        </footer>
    )
}
export default Footer;

// ©